export default "__VITE_ASSET__CbZr9lVB__"